import { render } from "./App.vue?vue&type=template&id=bddf9a82"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=bddf9a82&lang=css"

import exportComponent from "/codebuild/output/src3710787608/src/iristravel-hotel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__